import each from 'lodash/each'
import isObject from 'lodash/isObject'

export default function icon(svg, className, wrapAttrs) {
  let wrapAttr = ''
  if (isObject(wrapAttrs)) {
    each(wrapAttrs, (key, val) => {
      wrapAttr += ` ${key}`
      if (val !== null) {
        wrapAttr += `="${val}"`
      }
    })
  }

  return `<span class="icon ${className || ''}" ${wrapAttr}>${svg}</span>`
}
